import {
  AssetDetailsFormStep,
  StaticFieldToDisplayType,
} from "#src/batteries-included-components/Panels/FormPanels/AssetDetailsFormPanel/AssetDetailsFormStep";
import { useListCustomAttributes } from "#src/components/hooks/adapters/useCustomAttributes";
import {
  useListFlowProductCategories,
  useListFlowProductTypes,
} from "#src/components/hooks/adapters/useFlows";
import { useMultiStepFormContext } from "#src/hooks/useMultiStepForm";
import { AssetType, AttributeDataType, Resources } from "@validereinc/domain";
import { Flows } from "@validereinc/domain-controllers";
import React from "react";

const { FlowStatusOptions } = Flows.view;

export const FlowDetailsFormStep = () => {
  const { getStep } = useMultiStepFormContext();
  const prevStep = getStep(1);
  const prevStepValues = prevStep?.getValues();

  const { data: productCategories, isLoading: isLoadingFlowProductCategories } =
    useListFlowProductCategories();

  const { data: productTypes, isLoading: isLoadingFlowProductTypes } =
    useListFlowProductTypes();

  const { data: customAttributesData, isLoading: isLoadingCustomAttributes } =
    useListCustomAttributes({
      filters: { entity_type: AssetType.FLOW },
    });

  const customAttributes = customAttributesData?.data ?? [];

  const staticFieldsToDisplay: StaticFieldToDisplayType[] = [
    {
      field_name: "status",
      display_name: "Status",
      data_type: AttributeDataType.PICK_LIST,
      pick_list_values: FlowStatusOptions.map((option) => ({
        id: option.value,
        name: option.label,
      })),
      is_required: true,
    },
    {
      field_name: "product_category",
      display_name: "Product Category",
      data_type: AttributeDataType.PICK_LIST,
      pick_list_values:
        productCategories?.data?.map((option) => ({
          id: option.id,
          name: option.name,
        })) ?? [],
      is_required: true,
    },
    {
      field_name: "product_type",
      display_name: "Product Type",
      data_type: AttributeDataType.PICK_LIST,
      pick_list_values:
        productTypes?.data?.map((option) => ({
          id: option.id,
          name: option.name,
        })) ?? [],
      is_required: true,
    },
    ...customAttributes
      .filter((custom_attribute) =>
        custom_attribute.entity_subtypes
          ? custom_attribute.entity_subtypes.includes(
              prevStepValues?.type as string
            )
          : true
      )
      .sort((a, b) => Number(b.is_required) - Number(a.is_required))
      .map((custom_attribute) => {
        return {
          ...custom_attribute,
          field_name: `custom_attributes.${custom_attribute.field_name}`,
        } as typeof custom_attribute;
      }),
  ];

  const isLoading =
    isLoadingCustomAttributes ||
    isLoadingFlowProductCategories ||
    isLoadingFlowProductTypes;

  return (
    <AssetDetailsFormStep
      resourceType={Resources.FLOW}
      staticFieldsToDisplay={staticFieldsToDisplay}
      isLoadingFields={isLoading}
    />
  );
};
